const getElementId = (event, parentDivClass) => {
  const parentElement = event.target.closest(parentDivClass);
  let parentId;
  if (parentElement) {
    parentId = parentElement.getAttribute('id');
  }
  return parentId;
};

export default getElementId;
